import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  Modal,
  Paper,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import MainContainer from "../../layout/MainContainer";
import {
  useLazyDeleteCommentByIdQuery,
  useLazyGetCommentByPostQuery,
  useLazyGetPostByIdQuery,
  useLazyGetReportCommentByPostQuery,
} from "../../services/posts";
import { Loader, showError } from "../../constants";
import { Comments, PostResponse } from "../../types/General";
import { DocumentViewer, Pagination } from "../../components";
import WarnModal from "../../components/WarnModal";
import { handleDelete } from "../../utils/commonFunctions";
import {
  useLazyGetJourneyByIdQuery,
  useLazyJourneyCommentsQuery,
  useLazyReportCommentsJourneyQuery,
} from "../../services/advertiser";
import useTranslation from "../../hooks/Translation";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const JourneyDetails = () => {
  const location = useLocation();
  const { state } = location;
  const { id } = useParams();
  const [getCommentByPost] = useLazyGetCommentByPostQuery();
  const [reportedComment] = useLazyGetReportCommentByPostQuery();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [openDelete, setOpenDelete] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<string>("");

  const [value, setValue] = React.useState<number>(0);
  const [postDetail, setPostDetail] = useState<PostResponse>();
  const [comments, setComments] = useState<Comments[]>([]);
  const [reportComments, setReportComments] = useState<Comments[]>([]);
  const [uploadPreview, setUploadPreview] = useState<string>("");
  const [type, setType] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [selectedComment, setSelectedComment] = useState<Comments>();

  const [getPostById] = useLazyGetPostByIdQuery();
  const [deleteCommentById] = useLazyDeleteCommentByIdQuery();

  const [journey, setJourney] = useState<any>([]);
  const [journeyComments] = useLazyJourneyCommentsQuery();
  const [reportedComments] = useLazyReportCommentsJourneyQuery();

  const [getJourney, { isLoading }] = useLazyGetJourneyByIdQuery();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setModalOpen(false);
  };
  let totalPages = Math.ceil(totalCount / 10);

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const getJourneyDetails = async (id: string) => {
    try {
      const response = await getJourney({
        id: id,
      });
      console.log(response?.data?.data);
      if (response?.data?.statusCode === 200) {
        setJourney(response?.data?.data);
      } else {
        setJourney([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getComments = async (id: string | undefined) => {
    try {
      const response = await journeyComments({
        id: id,
        page: page,
        limit: 10,
      }).unwrap();
      console.log(response, "comments");
      if (response?.statusCode === 200) {
        setComments(response?.data?.comment);
        setTotalCount(response?.data?.commentCount);
      }
    } catch (error: any) {
      console.log(error, "errror");
      showError(error?.data?.message || "");
    }
  };

  const handlePopup = (image: string, type: string) => {
    setOpen(true);
    setUploadPreview(image);
    setType(type);
  };
  const getReportComments = async (id: string | undefined) => {
    try {
      console.log(id);
      const response = await reportedComments({
        id,
        page: page,
        limit: 10,
      }).unwrap();
      console.log(response, "report");
      if (response?.statusCode === 200) {
        console.log(response?.data);
        setReportComments(response?.data?.reportComment);
        setTotalCount(response?.data?.reportCommentCount);
      }
    } catch (error: any) {
      console.log("error");
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id) {
      getJourneyDetails(id);
    }
  }, []);

  useEffect(() => {
    if (value === 0) {
      console.log(id, "one");
      getReportComments(id);
    } else {
      getComments(id);
    }
  }, [value, page]);

  console.log(reportComments, "report");
  const translations = useTranslation() as any;
  return (
    <MainContainer>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">
            {translations.manage_journey.journey_details || ""}
          </h1>
          <Button
            className="btn btn_primary"
            onClick={() => {
              // eslint-disable-next-line no-lone-blocks
              {
                state.page === "Journey"
                  ? navigate("/manage-journeys")
                  : navigate("/manageusers/userdetails/" + journey?.userId);
              }
            }}
          >
             {translations.Globals.back || ""}
          </Button>
        </div>
        <Card className="cards">
          <CardContent sx={{ p: 1 }}>
            <Grid container spacing={2} className="view_box">
              <Grid item lg={12} md={12} sm={12} xs={12}>
                <Typography
                  className="detail_title mn_hdng"
                  component="h2"
                  mb={3}
                >
                 {translations.table_heads.user_details || ""}
                </Typography>
              </Grid>
              <Grid item xs={12} className="view_box_list">
                <Grid container spacing={3}>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translations.manage_journey.userName || ""}
                      </Typography>
                      <Typography component="p">
                        {journey?.userName || "-"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translations.manage_journey.phone || ""}
                      </Typography>
                      <Typography component="p">
                        {journey?.countryCode}
                        {journey?.phone}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item lg={3} md={3} sm={6} xs={12}>
                    <Box>
                      <Typography component="h5">
                        {translations.manage_journey.email || ""}
                      </Typography>
                      <Typography component="p">
                        {journey?.email || "-"}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item mt={3} xs={12} className="view_box_list">
                    <Typography
                      className="detail_title mn_hdng"
                      component="h2"
                      mb={3}
                    >
                      {translations.manage_journey.journey_details || ""}
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.uploads || ""}
                          </Typography>
                          <Box className="post_div">
                            {journey?.uploads?.length
                              ? journey?.uploads?.map((item: any) => {
                                  return (
                                    <>
                                      {item?.type === "IMAGE" ? (
                                        <figure
                                          style={{ cursor: "pointer" }}
                                          onClick={() =>
                                            handlePopup(item?.link, item?.type)
                                          }
                                        >
                                          <img src={item?.link || ""} alt="" />
                                        </figure>
                                      ) : (
                                        <video
                                          style={{ cursor: "pointer" }}
                                          autoPlay
                                          muted
                                          loop
                                          playsInline
                                          className="hm_vd"
                                          preload="yes"
                                          onClick={() =>
                                            handlePopup(item?.link, item?.type)
                                          }
                                        >
                                          <source
                                            src={item?.link || ""}
                                            type="video/mp4"
                                          />
                                        </video>
                                      )}
                                    </>
                                  );
                                })
                              : null}
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.title || ""}
                          </Typography>
                          <Typography component="p">
                            {" "}
                            {journey?.title || "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.desc || ""}
                          </Typography>
                          <Typography component="p">
                            {" "}
                            {journey?.description || "-"}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.upload_date || ""}
                          </Typography>
                          <Typography component="p">
                            {" "}
                            {moment(journey?.createdAt).format("DD/MM/YYYY")}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.upload_time || ""}
                          </Typography>
                          <Typography component="p">
                            {moment(journey?.createdAt).format("hh:mm:ss A")}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.category || ""}
                          </Typography>
                          <Typography component="p">
                            {journey?.categoryName || "-"}
                          </Typography>
                        </Box>
                      </Grid>

                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.total_comments || ""}
                          </Typography>
                          <Typography component="p">
                            {journey?.commentCount || 0}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.total_likes || ""}
                          </Typography>
                          <Typography component="p">
                            {journey?.likesCount || 0}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item lg={3} md={3} sm={6} xs={12}>
                        <Box>
                          <Typography component="h5">
                            {translations.manage_journey.share_count || ""}
                          </Typography>
                          <Typography component="p">
                            {journey?.shareCount || 0}
                          </Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card sx={{ mt: 4 }} className="cards">
          <Box className="custom_tabs">
            <Box className="flx_sc">
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons="auto"
                aria-label="basic tabs example"
                className="custom_tabs_links"
              >
                <Tab
                  label={translations.manage_journey.reported_comments || ""}
                  {...a11yProps(0)}
                />
                <Tab
                  label={translations.manage_journey.new_comments || ""}
                  {...a11yProps(1)}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        {translations.table_heads.sno || ""}
                      </TableCell>
                      <TableCell align="center">
                        {translations.table_heads.comments || ""}
                      </TableCell>
                      <TableCell align="center">
                        {translations.table_heads.report || ""}
                      </TableCell>

                      {/* <TableCell align="center">Likes</TableCell> */}
                      {/* <TableCell align="center">No. of Replies</TableCell>  */}
                      <TableCell>
                        {translations.table_heads.user_details || ""}
                      </TableCell>
                      <TableCell>
                        {translations.table_heads.actions || ""}
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {reportComments?.length > 0 ? (
                    reportComments?.map((row, i) => (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center">{i + 1}</TableCell>
                          <TableCell align="center">
                            {row?.commentText}
                          </TableCell>
                          <TableCell align="center">
                            {row?.reportContent || ""}
                          </TableCell>
                          {/* <TableCell align="center">
                            {row?.commentLikesCount}
                          </TableCell>
                          <TableCell align="center">
                            {row?.commentReply?.length}
                          </TableCell>  */}

                          <TableCell>
                            <Typography variant="h6" fontSize={14}>
                              {row?.userName || ""}
                            </Typography>
                            <Typography variant="h6" fontSize={14}>
                              {row?.userEmail || ""}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() => {
                                  setModalOpen(true);
                                  setSelectedComment(row);
                                }}
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton>
                                <DeleteIcon
                                  onClick={() => {
                                    setOpenDelete(true);
                                    setSelectedId(row?._id);
                                  }}
                                />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ))
                  ) : (
                    <TableBody>
                      <TableCell
                        align="center"
                        colSpan={10}
                        sx={{ color: "#051140" }}
                      >
                        {translations.manage_journey.no_comments || ""}
                      </TableCell>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className="table_container">
                <Box className="heading"></Box>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="center">
                        {translations.table_heads.sno || ""}
                      </TableCell>
                      <TableCell align="center">
                        {translations.table_heads.comments || ""}
                      </TableCell>
                      <TableCell align="center">
                        {translations.table_heads.likes || ""}
                      </TableCell>
                      <TableCell align="center">
                        {translations.table_heads.replies || ""}
                      </TableCell>

                      <TableCell> {translations.table_heads.user_details || ""}</TableCell>

                      <TableCell>{translations.table_heads.actions || ""}</TableCell>
                    </TableRow>
                  </TableHead>
                  {comments?.length > 0 ? (
                    comments?.map((row, i) => (
                      <TableBody>
                        <TableRow key={row?._id}>
                          <TableCell align="center">{i + 1}</TableCell>
                          <TableCell align="center">
                            {row?.commentText}
                          </TableCell>
                          <TableCell align="center">
                            {row?.commentLikesCount}
                          </TableCell>
                          <TableCell align="center">
                            {row?.commentReply?.length}
                          </TableCell>

                          <TableCell>
                            <Typography variant="h6" fontSize={14}>
                              {row?.userName}
                            </Typography>
                            <Typography variant="h6" fontSize={14}>
                              {row?.userEmail || ""}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Box className="table_actions">
                              <IconButton
                                onClick={() => {
                                  setModalOpen(true);
                                  setSelectedComment(row);
                                }}
                              >
                                <VisibilityIcon />
                              </IconButton>
                              <IconButton>
                                <DeleteIcon
                                  onClick={() => {
                                    setOpenDelete(true);
                                    setSelectedId(row?._id);
                                  }}
                                />
                              </IconButton>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ))
                  ) : (
                    <TableBody>
                      <TableCell
                        align="center"
                        colSpan={10}
                        sx={{ color: "#051140" }}
                      >
                        {translations.manage_journey.no_comments || ""}
                      </TableCell>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </CustomTabPanel>
          </Box>
        </Card>
        {value === 0 ? (
          <WarnModal
            setOpen={setOpenDelete}
            open={openDelete}
            name={translations.table_heads.comments || ""}
            handleDelete={() =>
              handleDelete(deleteCommentById, selectedId, () =>
                getReportComments(id)
              )
            }
          />
        ) : (
          <WarnModal
            setOpen={setOpenDelete}
            open={openDelete}
            name={translations.table_heads.comments || ""}
            handleDelete={() =>
              handleDelete(deleteCommentById, selectedId, () => getComments(id))
            }
          />
        )}
      </div>
      <Modal
        open={modalOpen}
        onClose={handleClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            padding: "20px",
            maxHeight: "80%",
            overflowY: "auto",
            minWidth: "60%",
            maxWidth: "60%",
          }}
        >
          <Typography variant="h6">
            {translations.manage_journey.replies || ""}
          </Typography>
          <ul className="cmnt_rplies">
            {selectedComment?.commentReply?.length ? (
              selectedComment?.commentReply?.map((item) => {
                return (
                  <li className="rply">
                    <div className="user_dtls">
                      <figure>
                        <img
                          src={
                            item?.commentReplyUserImage ||
                            "/static/images/user_placeholder.png"
                          }
                          alt=""
                        />
                      </figure>
                      <div className="userss">
                        <h2>
                          {translations.manage_journey.fname || ""}:{" "}
                          {item?.commentReplyUserName || "-"}
                        </h2>
                        <h2>
                          {translations.manage_journey.reply || ""}:{" "}
                          {item?.commentText || "-"}
                        </h2>
                        <h2>
                          {translations.manage_journey.date || ""}:{" "}
                          {moment(item?.createdAt).format("DD/MM/YYYY")}
                        </h2>
                      </div>
                    </div>
                  </li>
                );
              })
            ) : (
              <div>
                <h2
                  style={{
                    fontSize: "16px",
                    fontWeight: 500,
                    textAlign: "center",
                  }}
                >
                  {translations.manage_journey.no_replies || ""}
                </h2>
              </div>
            )}
          </ul>
        </Paper>
      </Modal>
      <DocumentViewer
        open={open}
        setOpen={setOpen}
        image={uploadPreview}
        type={type}
      />
    </MainContainer>
  );
};

export default JourneyDetails;
